// CAP-1976: a delete reaches a legal/beneficial interest pair server-side, so the confirm copy has
// to say what is really about to happen — and the two delete paths do different things. A SINGLE
// delete takes the pair whole. A BULK delete takes only the hidden counterpart (the ghost, which the
// user cannot select) and refuses a selection that leaves a visible sibling behind. The
// TSA-forbidden wording keeps precedence over both: a transaction the user cannot delete at all
// outranks a note about what would go with it.

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

export const bulkDeleteAlertDescription = (
	{
		investmentWorkflowIncluded,
		pairedLegsIncluded,
	}: { investmentWorkflowIncluded: boolean; pairedLegsIncluded: boolean },
	t: TranslateFn
): string => {
	if (investmentWorkflowIncluded) {
		return t('delete.transaction.drawer.bulk.forbiddenDescription');
	}
	if (pairedLegsIncluded) {
		return t('delete.transaction.drawer.bulk.pairedAlertDescription');
	}
	return t('delete.transaction.drawer.bulk.alertDescription');
};

export const singleDeleteAlertTitle = (
	{ tsaConnected, pairedLeg }: { tsaConnected: boolean; pairedLeg: boolean },
	t: TranslateFn
): string => {
	if (tsaConnected) {
		return t('delete.transaction.drawer.single.forbiddenTitle');
	}
	if (pairedLeg) {
		return t('delete.transaction.drawer.single.pairedAlertTitle');
	}
	return t('delete.transaction.drawer.single.alertTitle');
};

export const singleDeleteAlertDescription = (
	{ tsaConnected, pairedLeg }: { tsaConnected: boolean; pairedLeg: boolean },
	t: TranslateFn
): string => {
	if (tsaConnected) {
		return t('delete.transaction.drawer.single.forbiddenDescription');
	}
	if (pairedLeg) {
		return t('delete.transaction.drawer.single.pairedAlertDescription');
	}
	return t('delete.transaction.drawer.single.alertDescription');
};
